import React, { useEffect } from 'react'
import './App.css'
import axios from 'axios'
import Loader from './features/loader'
import MainPageActive from './features/main-page-active'
import MainPageBuyCertificate from './features/main-page-buy'
import { useStore } from 'effector-react'
import { certificateStore, pageStore, setCertificateStore } from './shared/state'
import MainPagePayCertificate from './features/main-page-pay'
import { MainPagePayed } from './features/main-page-payed'
import Footer from './features/footer'
import NotFoundPage from './features/not-found-page'

export async function copyTextToClipboard(text: string) {
    if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text)
    } else {
        return document.execCommand('copy', true, text)
    }
}
function App() {
    const certificate = useStore(certificateStore)
    const currentPage = useStore(pageStore)
    const queryParams = new URLSearchParams(window.location.search)
    const giftGuid = queryParams.get('guid')?.toString()

    const isPaymentComplete = queryParams.get('isPayed')?.toString() === 'true'

    useEffect(() => {
        if (giftGuid == undefined) {
            return
        }
        const request = async () => {
            const formData = new FormData()
            formData.append('guid', giftGuid)
            const result = await axios({
                method: 'post',
                url: 'https://app.giftyon.com/get_cert_online.php',
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' },
            })
            setCertificateStore(result.data)
        }
        request().then()
    }, [])

    let page = <Loader />
    if (certificate == null) {
        return page
    }

    if (currentPage == 'home') {
        if (isPaymentComplete) {
            page = <MainPagePayed certificate={certificate} />
        } else if (certificate?.type === 'INFO') {
            page = <MainPageBuyCertificate certificate={certificate} giftGuid={giftGuid} />
        } else if (certificate?.res_code === 93) {
            page = <NotFoundPage />
        } else if (certificate != null) {
            page = <MainPageActive certificate={certificate} giftGuid={giftGuid} />
        }
    }
    if (currentPage == 'pay') {
        page = <MainPagePayCertificate certificate={certificate}></MainPagePayCertificate>
    }

    return (
        <>
            {page}
            <Footer />
        </>
    )
}

export default App
